import fetch from '@adc/fetch'
import seek, { seekTypes } from '@adc/seek'
import { GRAPH_MARKET_ANALYSIS_QUERY } from '../queries/getExternalInformation'

export const fetchExternalInformationData = async listingId => {
  const seekQuery = seek.for(seekTypes.LISTINGS).size(1)

  seekQuery._query = {
    toObject: () => ({
      equals: {
        fields: 'listing_id',
        values: [+listingId],
      },
    }),
  }
  const dsl = JSON.stringify(seekQuery.toObject(false))
  const res = await fetch.forAuctionGraph({
    query: GRAPH_MARKET_ANALYSIS_QUERY,
    variables: { dsl },
  })

  const { external_information: vendorData, listing_configuration = {} } =
    res.body.data.seek.content[0]

  // NOTE: This looks odd. We do it only to match the existing data shape until until/if we refactor to removes the
  // variants and only code against the new interface.
  return {
    isHiddenPIR: vendorData?.is_property_report_hidden,
    reportdata: vendorData?.collateral,
    listing_configuration,
  }
}
